import Container from "@client/content/Containers/container";
import { Form } from "@client/content/controls";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { ModuleButton } from "@client/content/modules/Button";
import { type RootContainerProps } from "@client/content/types";
import { Alert } from "@client/controls/Alert/component";
import { type FormButtonProps, type FormData } from "@client/controls/Form/component";
import { Status } from "@client/types";
import { fieldValidation } from "@common/controls/Form/Field/lib";
import { EmailInput } from "@common/controls/Inputs/Text";
import { SystemColor } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";

export type MapProps = RootContainerProps & {
  showSuccessNotification: boolean;
  status: string;
};

export interface ActionProps {
  onClick: (data: FormData) => void;
}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  const FormButton = (innerProps: FormButtonProps) => (
    <ModuleButton
      {...getRootContainerProps(props)}
      isDisabled={props.status === Status.Saving}
      onClick={innerProps.ifValidated(props.onClick)}
    />
  );

  return (
    <Container className="wsc_content_forgot_password" {...getContainerProps(props)}>
      {props.showSuccessNotification ? (
        <Alert color={SystemColor.Green}>{i18n.resetPasswordSuccessNotification}</Alert>
      ) : (
        <Form
          {...getRootContainerProps(props)}
          fields={[
            {
              label: i18n.email,
              Component: EmailInput,
              name: "email",
              isRequired: true,
              validation: fieldValidation.email
            }
          ]}
          Button={FormButton}
        />
      )}
    </Container>
  );
};
